var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"class-type"},[_vm._v("課程日期")]),_vm._v(" "),(
      _vm.specificationDates &&
      _vm.specificationDates.length > 0 &&
      _vm.specificationDates[0].courseDate
    )?_c('div',{staticClass:"programPicker"},_vm._l((_vm.specificationDates),function(specificationDate,key){return (specificationDate.specificationPrograms.length > 0)?_c('div',{staticClass:"type-option",class:{ clicked: key == _vm.dateKey },domProps:{"textContent":_vm._s(specificationDate.courseDate)},on:{"click":function($event){return _vm.changeDateKey(key)}}}):_vm._e()}),0):_vm._e(),_vm._v(" "),_c('span',{staticClass:"class-type"},[_vm._v("方案選擇")]),_vm._v(" "),(
      _vm.specificationDates[_vm.dateKey] &&
      _vm.specificationDates[_vm.dateKey].specificationPrograms &&
      _vm.specificationDates[_vm.dateKey].specificationPrograms.length >
        0 &&
      _vm.specificationDates[_vm.dateKey].specificationPrograms[0]
        .programName
    )?_c('div',{staticClass:"SpecificationPicker"},_vm._l((_vm.specificationDates[
        _vm.dateKey
      ].specificationPrograms),function(specificationProgram,key){return _c('span',{staticClass:"type-option",class:{ clicked: key == _vm.programKey },domProps:{"textContent":_vm._s(specificationProgram.programName)},on:{"click":function($event){return _vm.changeProgramKey(key)}}})}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }